import { createURL_SSR, ROUTE } from "app-constants/routing"
import Exhibitor from "components/Exhibitor"
import { ActivityIndicator } from "components/activity-indicator"
import MainLayout from "components/main-layout"
import buildServerSidePage from "lib/build-server-side-page"
import buildServerSideProps from "lib/build-server-side-props"
import { getExhibitorName } from "lib/exhibitors/getExhibitorUtils"
import applyCache from "lib/mw/apply-cache"
import applyConvention from "lib/mw/apply-convention"
import applyCurrentContext from "lib/mw/apply-current-context"
import applyNextSeo from "lib/mw/apply-next-seo"
import applyRedirectForAutomaticallyGeneratedConvention from "lib/mw/apply-redirect-for-automatically-generated-convention"
import applyRequiredProps from "lib/mw/apply-required-props"
import applyTitle from "lib/mw/apply-title"
import ConventionProviderExhibitor from "models/convention-api/v1/ConventionProviderExhibitor"
import React from "react"

export const getServerSideProps = buildServerSideProps(
  applyCache(),
  applyCurrentContext(),
  applyConvention(),
  applyRedirectForAutomaticallyGeneratedConvention(),
  [
    async (context) => {
      await ConventionProviderExhibitor.applyOne("exhibitor", {
        filter: {
          disabled: "false",
          id: context.params.exhibitor_id as string,
        },
        includes: ["institution", "institution.chatAvailable"],
      })(context)
    },
  ],
  applyRequiredProps("exhibitor"),
  applyTitle(({ props }) => `${props.exhibitor.institution.name}`),
  applyNextSeo((context) => ({
    openGraph: {
      title: `${getExhibitorName(context.props.exhibitor)} - Profile`,
      url: createURL_SSR(context, {
        path: ROUTE.CONVENTION_EXHIBITOR,
        params: {
          conventionId: context.query.convention_id as string,
          exhibitorId: context.props.exhibitor.id,
        },
      }),
      type: "website",
      images: [
        {
          url: context.props.exhibitor.cover_photo_url,
          alt: `${getExhibitorName(context.props.exhibitor)} - Profile`,
        },
      ],
    },
  })),
)

interface ConventionExhibitorPageProps {
  exhibitor: ConventionProviderExhibitor
}

export default buildServerSidePage(function ConventionExhibitorPage(
  props: ConventionExhibitorPageProps,
) {
  const { exhibitor } = props

  if (!exhibitor)
    return (
      <MainLayout layout="micro">
        <ActivityIndicator />
      </MainLayout>
    )

  return (
    <MainLayout layout="micro">
      <Exhibitor exhibitor={exhibitor} />
    </MainLayout>
  )
})
